import {NgModule} from '@angular/core';
import {AppSelectElementDirective} from '@component/form/input/select/select-element.directive';
import {AppSelectGroupElementDirective} from '@component/form/input/select/select-group-element.directive';
import {AppSelectOptionElementDirective} from '@component/form/input/select/select-option-element.directive';
import {AppSelectFilterComponent} from '@component/form/input/select/select-filter/filter.component';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';
import {IconModule} from '@shared/icon/icon.module';
import {AppSelectElementPlaceholderOptionDirective} from '@component/form/input/select/select-element-placeholder.option';
import {AppSelectBookOptionDirective} from '@component/form/input/select/select-book-option.directive';
import {AppSelectExamOptionDirective} from '@component/form/input/select/select-exam-option.directive';

@NgModule({
    declarations: [
        AppSelectElementDirective,
        AppSelectGroupElementDirective,
        AppSelectOptionElementDirective,
        AppSelectBookOptionDirective,
        AppSelectExamOptionDirective,
        AppSelectElementPlaceholderOptionDirective,
        AppSelectFilterComponent,
    ],
    exports: [
        AppSelectElementDirective,
        AppSelectGroupElementDirective,
        AppSelectOptionElementDirective,
        AppSelectBookOptionDirective,
        AppSelectExamOptionDirective,
        AppSelectElementPlaceholderOptionDirective,
        AppSelectFilterComponent,
    ],
    imports: [
        MatInputModule,
        TranslateModule,
        IconModule,
    ],
})
export class AppSelectModule {
}
